import React from "react";
import Lottie from "react-lottie";
import emptyFile from "../assets/images/lottie/empty_file.json";
import styled from "styled-components";
import { Ptag } from "./fonts";

function EmptyTable() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: emptyFile,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <MessageDiv>
      <FlexColumn>
        <Lottie
          options={defaultOptions}
          height={120}
          width={120}
          style={{ opacity: "1" }}
          isClickToPauseDisabled
        />
        <Ptag fontSize="18px" fontWeight="600" lineHeight="20">
          No Data Available
        </Ptag>
      </FlexColumn>
    </MessageDiv>
  );
}

const MessageDiv = styled.div`
  height: 50vh;
  margin-top: 1.5rem;
  background: rgba(201, 211, 231, 0.214);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`

export default EmptyTable;
